export default [
  {
    Resolution: 0.25,
    LimitSueface: 100,
    LayerName: 'OI.OrthoimageCoverage',
    ServiceType: 'TMS',
    // eslint-disable-next-line no-template-curly-in-string
    URL: 'http://mt.google.com/vt/lyrs=s&amp;x=${x}&amp;y=${y}&amp;z=${z}',
    BatchSize: 32,
    StepPerEpoch: 20,
    ValidationStep: 100
  }
];
